import { PutCrecaAccountsApi } from "@/features/accounts/creca/services/put-accounts-api";
import { PutCrecaAccountsRequestModel } from "@/features/accounts/creca/services/put-accounts-model";

/// クレカ更新処理
export class PutCrecaAccountsService {
  private putCrecaAccountsApi = new PutCrecaAccountsApi();

  /**
   * クレカ更新API実行
   */
  public async putCrecaAccounts(param: PutCrecaAccountsRequestModel) {
    return await this.putCrecaAccountsApi.putCrecaAccounts(param);
  }
}
